import { styled } from "@mui/material/styles";
import { Fab, Typography } from "@mui/material";
import { TIPPSPIEL_BOX_SHADOW } from "../../../styles";

export const RefreshContentFab = styled(Fab, {
    shouldForwardProp: (prop) => prop !== "withOrangeColorStyles",
})<{ withOrangeColorStyles?: boolean }>(
    ({ withOrangeColorStyles = false }) => ({
        height: "36px !important",
        width: "fit-content !important",
        boxShadow: TIPPSPIEL_BOX_SHADOW,
        padding: "0 8px",
        gap: "8px",
        ...(withOrangeColorStyles
            ? {
                  backgroundColor: "#f07c01e6",
                  color: "var(--community-color-snow-white)",
                  ":hover": {
                      backgroundColor: "#f07c01e6",
                  },
              }
            : {
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  color: "var(--community-color-primary-text)",
                  ":hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.9)",
                  },
              }),
    }),
);

export const RefreshContentTypography = styled(Typography)({
    fontSize: "16px",
    textTransform: "none",
});
